import { Observable } from '../tools/observable';
export const TrackingConsent = {
  GRANTED: 'granted',
  NOT_GRANTED: 'not-granted'
};
export function createTrackingConsentState(currentConsent) {
  const observable = new Observable();
  return {
    tryToInit(trackingConsent) {
      if (!currentConsent) {
        currentConsent = trackingConsent;
      }
    },
    update(trackingConsent) {
      currentConsent = trackingConsent;
      observable.notify();
    },
    isGranted() {
      return currentConsent === TrackingConsent.GRANTED;
    },
    observable
  };
}
